// v24: on phones the page's main button (the hero's first button, its own words and link) stays at hand in a bar at
// the bottom of the screen once the hero has scrolled away. It steps aside where the page already offers the same
// choice (the plans, the closing call to action, the footer) and while someone is typing. Styles: dex-v24.css.
(() => {
  const btn = document.querySelector('.dex-hero__actions .dex-btn--primary, .dex-pagehero .dex-btn--primary');
  if (!btn || !('IntersectionObserver' in window)) return;
  const phone = matchMedia('(max-width: 749px)');
  const bar = document.createElement('div');
  bar.className = 'dex-mbar';
  const link = btn.cloneNode(true);
  link.removeAttribute('id');
  link.classList.remove('dex-btn--lg');
  link.classList.add('dex-mbar__btn');
  bar.appendChild(link);
  document.body.appendChild(bar);

  const hero = btn.closest('section') || btn;
  const stops = document.querySelectorAll('.dex-plans, .dex-cta, footer, .footer');
  const inView = new Set();
  let pastHero = false;
  const update = () => {
    const f = document.activeElement;
    const typing = f && /^(INPUT|TEXTAREA|SELECT)$/.test(f.tagName) && f.type !== 'radio' && f.type !== 'checkbox';
    bar.classList.toggle('is-on', phone.matches && pastHero && inView.size === 0 && !typing);
  };
  new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(hero);
  const watch = new IntersectionObserver((list) => {
    list.forEach((e) => (e.isIntersecting ? inView.add(e.target) : inView.delete(e.target)));
    update();
  });
  stops.forEach((s) => watch.observe(s));
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => setTimeout(update, 60));
  if (phone.addEventListener) phone.addEventListener('change', update);
})();
